'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('upload-archive', {
      url: '/upload/archive',
      template: '<upload-archive></upload-archive>',
        authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/upload/archive/upload-archive.routes.js